import { render, staticRenderFns } from "./avantages.vue?vue&type=template&id=2a5a07fb&"
import script from "./avantages.vue?vue&type=script&lang=js&"
export * from "./avantages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports